import React from 'react';
import Tabs, * as Bootstrap from 'react-bootstrap/Tabs';

export default (props: Bootstrap.TabsProps) => (
  <Tabs {...props} mountOnEnter unmountOnExit>
    {props.children}
  </Tabs>
);
